import './CtaExplainStyle.less';

import classNames from 'classnames';
import * as React from 'react';

export interface ICtaExplainProps {
  actionText: string;
  actionTextSmall?: string;
  explainStyle?: 'info' | 'warning' | 'error';
  designStyle?: 'rounded' | 'squared';
  marginType?: 'medium' | 'none';
  size?: 'medium' | 'large';
}

// This is essentially a "beta" bricks components. Rohan and I didn't want
// to add it to the bricks library without a robust design review, but it's
// reasonable to experiment with it (currently used in the EmailCallToAction flow).
export default class CtaInfo extends React.PureComponent<ICtaExplainProps> {
  public static defaultProps: Partial<ICtaExplainProps> = {
    designStyle: 'squared',
    explainStyle: 'info',
    marginType: 'none',
    size: 'medium',
  };

  public render() {
    const { designStyle, explainStyle, marginType, size } = this.props;

    const computedClasses = classNames(
      size,
      'text-medium',
      'cta-explain',
      `design-style-${designStyle}`,
      `margin-type-${marginType}`,
      `explain-style-${explainStyle}`,
    );

    return <div className={computedClasses}>{this.displayButtonText()}</div>;
  }

  private displayButtonText = () => {
    const { actionText, actionTextSmall } = this.props;

    return (
      <span>
        <span className="hidden-xs-down">{actionText}</span>
        <span className="hidden-sm-up">{actionTextSmall ? actionTextSmall : actionText}</span>
      </span>
    );
  };
}
